//
//
//
//
//
//

import * as monaco from "monaco-editor";
import { MONACO_EDITOR_PROPS } from "./AQMonacoEditor.const";

export default {
    name: "AQMonacoDiffEditor",
    props: {
        ...MONACO_EDITOR_PROPS
    },
    data() {
        return {
            editor: ""
        };
    },
    mounted() {
        this.createDiffEditor();
    },
    methods: {
        createDiffEditor() {
            const el = this.$refs.diffEditor;
            this.editor = monaco.editor.createDiffEditor(el,
                {
                    renderSideBySide: false,
                    automaticLayout: this.autoResize,
                    theme: this.theme,
                    language: this.language,
                    readOnly: this.readonly
                });
            this.editor.setModel({
                original: monaco.editor.createModel(this.value, this.language),
                modified: monaco.editor.createModel(this.diffValue, this.language)
            });
        }
    }
};
